import Banner from "../../../components/BannerNew";
import Styles from "../../../components/Styles";
import Popular from "../../../components/Popular";
import Copyrights from "../../../components/Copyrights";
import Footer from "../../../components/Footer";
import { useTranslation } from "react-i18next";
import HotelHeader from "../../../components/hotel/Header";
import HotelBanner from "../../../components/hotel/Banner";
import Header from "../../../components/Header";
import FeaturedHotels from "../../../components/hotel/featuredHotels";
import { useState, useEffect } from "react"

const Hotel = () => {
  const translationContext = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div style={{ position: 'relative', overflow: 'visible' }}>
      <Styles />
      {!isMobile && (
        <Header
          translation={translationContext.t}
          translationContext={translationContext}
        />
      )}
      <HotelBanner translation={translationContext.t} translationContext={translationContext} />
      <FeaturedHotels translation={translationContext.t} />
      <Footer />
      <Copyrights />
    </div>
  );
};

export default Hotel;
